import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadContractRentAmountListStatus: 'idle',
    loadContractRentAmountListError: undefined as any,
    loadContractRentAmountListLastArgs: undefined as any,
    loadContractRentAmountStatus: 'idle',
    loadContractRentAmountError: undefined as any,
    createContractRentAmountStatus: 'idle',
    createContractRentAmountError: undefined as any,
    updateContractRentAmountStatus: 'idle',
    updateContractRentAmountError: undefined as any,
    deleteContractRentAmountStatus: 'idle',
    deleteContractRentAmountError: undefined as any,
    loadSollartListStatus: 'idle',
    loadSollartListError: undefined as any,
    loadSollartListLastArgs: undefined as any,
    loadSollartStateListStatus: 'idle',
    loadSollartStateListError: undefined as any,
    loadSollartStateListLastArgs: undefined as any,
    loadPartialRentAmountStatus: 'idle',
    loadPartialRentAmountError: undefined as any,
    loadStepRentAmountsStatus: 'idle',
    loadStepRentAmountsError: undefined as any,
    loadPartialRentInfoStatus: 'idle',
    loadPartialRentInfoError: undefined as any,
    loadPerRentAmountListStatus: 'idle',
    loadPerRentAmountListError: undefined as any,
    loadPerRentAmountListLastArgs: undefined as any,
    createPerRentAmountStatus: 'idle',
    createPerRentAmountError: undefined as any,

    flsolList: [] as any[],
    formItem: undefined as any,
    partialRentAmount: undefined as any,
    partRentInfo: undefined as any,
    sollartList: [] as any,
    sollartStateList: [] as any,
    stepRentAmounts: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadContractRentAmountList = createAsyncThunk('flsolSlice/loadContractRentAmountList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().flsolSlice.loadContractRentAmountListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/flsol/?index_name=FLSOL_KEY1&action=gte&MIN_OBJNR=${parentModel.OBJNR}&MAX_OBJNR=${parentModel.OBJNR}&MIN_PNO=${parentModel.PNO}&MAX_PNO=${parentModel.PNO}&MIN_FLSTMNR=${parentModel.FLSTMNR}&MAX_FLSTMNR=${parentModel.FLSTMNR}&MIN_KKL=001&MAX_KKL=999&MIN_DAT=${parentModel.BEGIN}&MAX_DAT=${parentModel.BEGIN}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadContractRentAmountListStatus } = getState().flsolSlice
        return loadContractRentAmountListStatus !== 'pending'
    }
})

export const loadContractRentAmount = createAsyncThunk('flsolSlice/loadContractRentAmount', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/flsol/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadContractRentAmountStatus } = getState().flsolSlice
        return loadContractRentAmountStatus !== 'pending'
    }
})

export const createContractRentAmount = createAsyncThunk('flsolSlice/createContractRentAmount', async ({ parentModel, flsol }: any, { rejectWithValue }: any) => {
    let promises = []
    if (flsol?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/flsol/${ flsol?.HDR_ID }/`,
            prepareData({ PNO: parentModel.PNO, FLSTMNR: parentModel.FLSTMNR, ...flsol }),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/flsol/`,
            prepareData({ PNO: parentModel.PNO, FLSTMNR: parentModel.FLSTMNR, ...flsol }),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { createContractRentAmountStatus } = getState().flsolSlice
        return createContractRentAmountStatus !== 'pending'
    }
})

export const updateContractRentAmount = createAsyncThunk('flsolSlice/updateContractRentAmount', async ({ flsol }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.put(
        `/api/ixweb/flsol/${flsol.HDR_ID}/`,
        prepareData(flsol),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { updateContractRentAmountStatus } = getState().flsolSlice
        return updateContractRentAmountStatus !== 'pending'
    }
})

export const deleteContractRentAmount = createAsyncThunk('flsolSlice/deleteContractRentAmount', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/flsol/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteContractRentAmountStatus } = getState().flsolSlice
        return deleteContractRentAmountStatus !== 'pending'
    }
})

export const loadSollartList = createAsyncThunk('flsolSlice/loadSollartList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().flsolSlice.loadSollartListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/sollart/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadSollartListStatus } = getState().flsolSlice
        return loadSollartListStatus !== 'pending'
    }
})

export const loadSollartStateList = createAsyncThunk('flsolSlice/loadSollartStateList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().flsolSlice.loadSollartStateListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/sollartstate/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadSollartStateListStatus } = getState().flsolSlice
        return loadSollartStateListStatus !== 'pending'
    }
})

export const loadPartialRentAmount = createAsyncThunk('flsolSlice/loadPartialRentAmount', async ({ flsol }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/partial-rent-amount/?Type=${flsol.PartialRentCalcType}&date=${flsol.DAT}&value=${flsol.VAL}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadPartialRentAmountStatus } = getState().flsolSlice
        return loadPartialRentAmountStatus !== 'pending'
    }
})

export const loadStepRentAmounts = createAsyncThunk('flsolSlice/loadStepRentAmounts', async ({ parentModel, flsol }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/Contract_CalculateStepRent/?parentModelId=${parentModel.HDR_ID}&KKL=${flsol.KKL}&initial_value=${flsol.VAL}&step_rent_start_date=${flsol.DAT}&increase_type=${flsol.StepRentIncreaseType}&increase_value=$[flsol.StepRentIncreaseValue}&increase_interval_monate=${flsol.StepRentIncreaseMonthsInterval}&increse_years=${flsol.StepRentIncreaseYears}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadStepRentAmountsStatus } = getState().flsolSlice
        return loadStepRentAmountsStatus !== 'pending'
    }
})

export const loadPartialRentInfo = createAsyncThunk('flsolSlice/loadPartialRentInfo', async ({ parentModel, flsol }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/Contract_CalculatePartialRentInfo/?OBJNR=${parentModel.OBJNR}&PNO=${parentModel.PNO}&FLSTMNR=${parentModel.FLSTMNR}&parentModelBEGINN=${parentModel.BEGINN}&KKL=${flsol.KKL}&DAT=${flsol.DAT}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadPartialRentInfoStatus } = getState().flsolSlice
        return loadPartialRentInfoStatus !== 'pending'
    }
})

export const loadPerRentAmountList = createAsyncThunk('flsolSlice/loadPerRentAmountList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().flsolSlice.loadPerRentAmountListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/flsol/?index_name=FLSOL_KEY1&action=gte&MIN_OBJNR=${parentModel.OBJNR}&MAX_OBJNR=${parentModel.OBJNR}&MIN_PNO=${parentModel.NO}&MAX_PNO=${parentModel.NO}&MIN_FLSTMNR=0&MAX_FLSTMNR=0`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadPerRentAmountListStatus } = getState().flsolSlice
        return loadPerRentAmountListStatus !== 'pending'
    }
})

export const createPerRentAmount = createAsyncThunk('flsolSlice/createPerRentAmount', async ({ parentModel, flsol }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/flsol/`,
        prepareData({ ...flsol, PNO: parentModel.NO, FLSTMNR: 0 }),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { createPerRentAmountStatus } = getState().flsolSlice
        return createPerRentAmountStatus !== 'pending'
    }
})

const FlsolSlice = createSlice({
    name: 'flsolSlice',
    initialState,
    reducers: {
        resetloadContractRentAmountListError: (state) => {
            state.loadContractRentAmountListError = undefined
        },
        resetloadContractRentAmount: (state) => {
            state.formItem = undefined
            state.loadContractRentAmountError = undefined
        },
        resetloadContractRentAmountError: (state) => {
            state.loadContractRentAmountError = undefined
        },
        resetcreateContractRentAmount: (state) => {
            state.formItem = undefined
            state.createContractRentAmountError = undefined
        },
        resetcreateContractRentAmountError: (state) => {
            state.createContractRentAmountError = undefined
        },
        resetupdateContractRentAmountError: (state) => {
            state.updateContractRentAmountError = undefined
        },
        resetdeleteContractRentAmountError: (state) => {
            state.deleteContractRentAmountError = undefined
        },
        resetloadSollartList: (state) => {
            state.sollartList = undefined
            state.loadSollartListError = undefined
        },
        resetloadSollartListError: (state) => {
            state.loadSollartListError = undefined
        },
        resetloadSollartStateList: (state) => {
            state.sollartStateList = undefined
            state.loadSollartStateListError = undefined
        },
        resetloadSollartStateListError: (state) => {
            state.loadSollartStateListError = undefined
        },
        resetloadPartialRentAmount: (state) => {
            state.partialRentAmount = undefined
            state.loadPartialRentAmountError = undefined
        },
        resetloadPartialRentAmountError: (state) => {
            state.loadPartialRentAmountError = undefined
        },
        resetloadStepRentAmounts: (state) => {
            state.stepRentAmounts = undefined
            state.loadStepRentAmountsError = undefined
        },
        resetloadStepRentAmountsError: (state) => {
            state.loadStepRentAmountsError = undefined
        },
        resetloadPartialRentInfo: (state) => {
            state.partRentInfo = undefined
            state.loadPartialRentInfoError = undefined
        },
        resetloadPartialRentInfoError: (state) => {
            state.loadPartialRentInfoError = undefined
        },
        resetloadPerRentAmountListError: (state) => {
            state.loadPerRentAmountListError = undefined
        },
        resetcreatePerRentAmountError: (state) => {
            state.createPerRentAmountError = undefined
        },
        removeFromFlsolListById: (state, action) => {
            state.flsolList = state.flsolList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromFlsolListByIds: (state, action) => {
            state.flsolList = state.flsolList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        removeFromSollartListById: (state, action) => {
            state.sollartList = state.sollartList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromSollartListByIds: (state, action) => {
            state.sollartList = state.sollartList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        removeFromSollartStateListById: (state, action) => {
            state.sollartStateList = state.sollartStateList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromSollartStateListByIds: (state, action) => {
            state.sollartStateList = state.sollartStateList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.flsolList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadContractRentAmountListStatus = 'preloaded'
            state.loadContractRentAmountListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.flsolList = []
            state.loadContractRentAmountListStatus = 'idle'
            state.loadContractRentAmountListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadContractRentAmountList.pending, (state) => {
            state.loadContractRentAmountListStatus = 'pending'
            state.loadContractRentAmountListError = undefined
        })
        builder.addCase(loadContractRentAmountList.fulfilled, (state, action) => {
            state.loadContractRentAmountListStatus = 'idle'

            if (!action.payload) { return }

            state.loadContractRentAmountListLastArgs = action.payload.args

            {
                state.flsolList = action.payload.data

            }
        })
        builder.addCase(loadContractRentAmountList.rejected, (state, action) => {
            state.loadContractRentAmountListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadContractRentAmountListError = action.error.message
            } else {
                state.loadContractRentAmountListError = action.payload
            }
        })

        builder.addCase(loadContractRentAmount.pending, (state) => {
            state.loadContractRentAmountStatus = 'pending'
            state.loadContractRentAmountError = undefined
        })
        builder.addCase(loadContractRentAmount.fulfilled, (state, action) => {
            state.loadContractRentAmountStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flsolList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flsolList.push(newItem) }
                else { state.flsolList[i] = { ...state.flsolList[i], ...newItem } }
            }
        })
        builder.addCase(loadContractRentAmount.rejected, (state, action) => {
            state.loadContractRentAmountStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadContractRentAmountError = action.error.message
            } else {
                state.loadContractRentAmountError = action.payload
            }
        })

        builder.addCase(createContractRentAmount.pending, (state) => {
            state.createContractRentAmountStatus = 'pending'
            state.createContractRentAmountError = undefined
        })
        builder.addCase(createContractRentAmount.fulfilled, (state, action) => {
            state.createContractRentAmountStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flsolList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flsolList.push(newItem) }
                else { state.flsolList[i] = { ...state.flsolList[i], ...newItem } }
            }
        })
        builder.addCase(createContractRentAmount.rejected, (state, action) => {
            state.createContractRentAmountStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.createContractRentAmountError = action.error.message
            } else {
                state.createContractRentAmountError = action.payload
            }
        })

        builder.addCase(updateContractRentAmount.pending, (state) => {
            state.updateContractRentAmountStatus = 'pending'
            state.updateContractRentAmountError = undefined
        })
        builder.addCase(updateContractRentAmount.fulfilled, (state, action) => {
            state.updateContractRentAmountStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flsolList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flsolList.push(newItem) }
                else { state.flsolList[i] = { ...state.flsolList[i], ...newItem } }
            }
        })
        builder.addCase(updateContractRentAmount.rejected, (state, action) => {
            state.updateContractRentAmountStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.updateContractRentAmountError = action.error.message
            } else {
                state.updateContractRentAmountError = action.payload
            }
        })

        builder.addCase(deleteContractRentAmount.pending, (state) => {
            state.deleteContractRentAmountStatus = 'pending'
            state.deleteContractRentAmountError = undefined
        })
        builder.addCase(deleteContractRentAmount.fulfilled, (state, action) => {
            state.deleteContractRentAmountStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.flsolList = state.flsolList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.flsolList = state.flsolList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteContractRentAmount.rejected, (state, action) => {
            state.deleteContractRentAmountStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteContractRentAmountError = action.error.message
            } else {
                state.deleteContractRentAmountError = action.payload
            }
        })

        builder.addCase(loadSollartList.pending, (state) => {
            state.loadSollartListStatus = 'pending'
            state.loadSollartListError = undefined
        })
        builder.addCase(loadSollartList.fulfilled, (state, action) => {
            state.loadSollartListStatus = 'idle'

            if (!action.payload) { return }

            state.loadSollartListLastArgs = action.payload.args

            {
                state.sollartList = action.payload.data

            }
        })
        builder.addCase(loadSollartList.rejected, (state, action) => {
            state.loadSollartListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadSollartListError = action.error.message
            } else {
                state.loadSollartListError = action.payload
            }
        })

        builder.addCase(loadSollartStateList.pending, (state) => {
            state.loadSollartStateListStatus = 'pending'
            state.loadSollartStateListError = undefined
        })
        builder.addCase(loadSollartStateList.fulfilled, (state, action) => {
            state.loadSollartStateListStatus = 'idle'

            if (!action.payload) { return }

            state.loadSollartStateListLastArgs = action.payload.args

            {
                state.sollartStateList = action.payload.data

            }
        })
        builder.addCase(loadSollartStateList.rejected, (state, action) => {
            state.loadSollartStateListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadSollartStateListError = action.error.message
            } else {
                state.loadSollartStateListError = action.payload
            }
        })

        builder.addCase(loadPartialRentAmount.pending, (state) => {
            state.loadPartialRentAmountStatus = 'pending'
            state.loadPartialRentAmountError = undefined
        })
        builder.addCase(loadPartialRentAmount.fulfilled, (state, action) => {
            state.loadPartialRentAmountStatus = 'idle'

            {
                state.partialRentAmount = action.payload

            }
        })
        builder.addCase(loadPartialRentAmount.rejected, (state, action) => {
            state.loadPartialRentAmountStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadPartialRentAmountError = action.error.message
            } else {
                state.loadPartialRentAmountError = action.payload
            }
        })

        builder.addCase(loadStepRentAmounts.pending, (state) => {
            state.loadStepRentAmountsStatus = 'pending'
            state.loadStepRentAmountsError = undefined
        })
        builder.addCase(loadStepRentAmounts.fulfilled, (state, action) => {
            state.loadStepRentAmountsStatus = 'idle'

            {
                state.stepRentAmounts = action.payload

            }
        })
        builder.addCase(loadStepRentAmounts.rejected, (state, action) => {
            state.loadStepRentAmountsStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadStepRentAmountsError = action.error.message
            } else {
                state.loadStepRentAmountsError = action.payload
            }
        })

        builder.addCase(loadPartialRentInfo.pending, (state) => {
            state.loadPartialRentInfoStatus = 'pending'
            state.loadPartialRentInfoError = undefined
        })
        builder.addCase(loadPartialRentInfo.fulfilled, (state, action) => {
            state.loadPartialRentInfoStatus = 'idle'

            {
                state.partRentInfo = action.payload

            }
        })
        builder.addCase(loadPartialRentInfo.rejected, (state, action) => {
            state.loadPartialRentInfoStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadPartialRentInfoError = action.error.message
            } else {
                state.loadPartialRentInfoError = action.payload
            }
        })

        builder.addCase(loadPerRentAmountList.pending, (state) => {
            state.loadPerRentAmountListStatus = 'pending'
            state.loadPerRentAmountListError = undefined
        })
        builder.addCase(loadPerRentAmountList.fulfilled, (state, action) => {
            state.loadPerRentAmountListStatus = 'idle'

            if (!action.payload) { return }

            state.loadPerRentAmountListLastArgs = action.payload.args

            {
                state.flsolList = action.payload.data

            }
        })
        builder.addCase(loadPerRentAmountList.rejected, (state, action) => {
            state.loadPerRentAmountListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadPerRentAmountListError = action.error.message
            } else {
                state.loadPerRentAmountListError = action.payload
            }
        })

        builder.addCase(createPerRentAmount.pending, (state) => {
            state.createPerRentAmountStatus = 'pending'
            state.createPerRentAmountError = undefined
        })
        builder.addCase(createPerRentAmount.fulfilled, (state, action) => {
            state.createPerRentAmountStatus = 'idle'

            {
                state.flsolList = [...state.flsolList, Array.isArray(action.payload) ? action.payload[0] : action.payload]
            }
        })
        builder.addCase(createPerRentAmount.rejected, (state, action) => {
            state.createPerRentAmountStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.createPerRentAmountError = action.error.message
            } else {
                state.createPerRentAmountError = action.payload
            }
        })

    }
})

export const {
    resetloadContractRentAmountListError,
    resetloadContractRentAmount,
    resetloadContractRentAmountError,
    resetcreateContractRentAmount,
    resetcreateContractRentAmountError,
    resetupdateContractRentAmountError,
    resetdeleteContractRentAmountError,
    resetloadSollartList,
    resetloadSollartListError,
    resetloadSollartStateList,
    resetloadSollartStateListError,
    resetloadPartialRentAmount,
    resetloadPartialRentAmountError,
    resetloadStepRentAmounts,
    resetloadStepRentAmountsError,
    resetloadPartialRentInfo,
    resetloadPartialRentInfoError,
    resetloadPerRentAmountListError,
    resetcreatePerRentAmountError,
    removeFromFlsolListById,
    removeFromFlsolListByIds,
    removeFromSollartListById,
    removeFromSollartListByIds,
    removeFromSollartStateListById,
    removeFromSollartStateListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = FlsolSlice.actions
export default FlsolSlice.reducer
